import * as types from './constants';

const initialState = {
  // Keyed by collection GID: { id, variants_count, is_more }. Accumulates as rows come into view,
  // so scrolling back up does not re-ask for a count already paid for.
  counts: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Shopify Collection Variant Counts
  [types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      counts: { ...state.counts, ...payload.counts },
      loading: false
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
